module.exports = __webpack_public_path__ + "static/klimaatverandering-droogte-nederland-mobile-4287a3362e778f1f9ebf1e50c9cb2a22.jpg";